import { FormHelperText } from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";
import { LabelWithIcon } from "../label";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { APP_COLORS } from "../../../enums";

export function FormHelperTextError({
  messageType = "error",
  showIcon = false,
  sx = {},
  id,
  error,
  helperText = "",
  showError = true,
}: any) {
  if (!showError) return null;

  return (
    <FormHelperText
      sx={{
        color: !error && helperText ? APP_COLORS.textLight : getColor(messageType),
        ml: 0,
        ...sx,
      }}
      id={id}
    >
      {showIcon && error ? (
        <LabelWithIcon icon={getIcon(messageType)} label={error} />
      ) : (
        error || helperText
      )}
    </FormHelperText>
  );
}

export { SomethingWentWrong } from "./SomethingWentWrong";

function getColor(messageType) {
  switch (messageType) {
    case "info":
      return "secondary.main";
    default:
      return "error.main";
  }
}

function getIcon(messageType) {
  switch (messageType) {
    case "info":
      return <ErrorOutlineIcon color="secondary" />;
    default:
      return <ErrorIcon color="error" />;
  }
}